export interface BreadcrumbOption {
  label: string;
  redirectUrl?: string;
  queryParams?: Record<string, unknown>;
  data?: any;
}
